import React, { useEffect, useReducer, useRef, useState } from 'react'
import styles from './styles'
import btnStyles from '../styles'
import formSettings from './formSettings'
import FormContent from './FormContent'
import axios from 'axios'
import axiosConfig from '../../../../config/axios.config'
import { Icons } from '@xpertdox_js/xdcomponents'
import { validatorReducer, validatorsInitialState } from '../../../validatorReducer'
import { trackActivity, trackError } from '../../../../utils/activityTracker'
import { UserContext } from '../../../../Context/UserContext'
import { InstanceContext } from '../../../../InstanceContext'

const ManualTrial = props => {
  const { setManual, done } = props
  const { sections } = formSettings.trial
  const [mutations, setMutations] = useState([])
  const [subState, setSubState] = useState(0)
  const [ageCheck, setAgeCheck] = useState(false)
  const [edit, setEdit] = useState(false)
  const [ageWarning, setAgeWarning] = useState(false)
  const [validators, dispatch] = useReducer(validatorReducer, validatorsInitialState)
  const { user, userAction } = React.useContext(UserContext)
  const { contextInstance } = React.useContext(InstanceContext)

  const manualTrialForm = useRef({
    title: '',
    briefDescription: '',
    eligibilityCriteria: '',
    startDate: '',
    endDate: '',
    leadSponsor: '',
    minAge: '',
    maxAge: '',
    studyType: '',
    healthyVolunteers: '',
    mutationsIN: '',
    mutationsOUT: '',
    pscore: '',
    position: '',
    extraInfo: '',
    conditions: '',
    studyNotes: '',
    genderToEdit: '',
    recurrentToEdit: '',
    phaseToEdit: '',
    customDescription: '',
    studyPopulation: '',
    whatsInvolved: ''
  })

  const formState = () => {
    setSubState(subState + 1)
  }

  const handleActivityLogUpdate = (_id) => {
    trackActivity({
      body: {
        _id,
        instance: contextInstance || user.instance,
        user: user.id
      }
    })
  }

  const saveManual = () => {
    handleActivityLogUpdate(`ManualTrial.saveManual`)
    if (ageCheck) dispatch({ type: 'manual', data: manualTrialForm.current })
    else setAgeWarning(true)
  }

  const sendManualData = () => {
    // removed 'axiosConfig.auth' as token is updated on login
    if (props.manualTrialToEdit) axios.post(`${axiosConfig.apiUrl}/rt/console/editManualTrial/${props.context.auth.email}/${props.context.instance}`, manualTrialForm.current).then(result => {
      done()
    }).catch((err) => {
      console.log(err)
      trackError({ error: err, history: props.history })
      if (err && err.response && err.response.status === 403) {
        userAction({type: 'logout'})
      }
    })
    else axios.post(`${axiosConfig.apiUrl}/rt/console/saveManualTrial/${props.context.auth.email}/${props.context.instance}`, manualTrialForm.current).then(result => {
      done()
    }).catch((err) => {
      console.log(err)
      trackError({ error: err, history: props.history })
      if (err && err.response && err.response.status === 403) {
        userAction({type: 'logout'})
      }
    })
  }

  // removed 'axiosConfig.auth' as token is updated on login
  const fetchFilters = () => axios.get(`${axiosConfig.apiUrl}/rt/getFilterData?send=DiseaseStage,TreatmentStatus,Mutations,Labs,VitalSigns,LungFunctionTest,PrimaryPurpose,CardiovascularTests`).then(res => {
    if (res.data.mutations.length > 0) {
      let mutationsOptions = res.data.mutations.map(m => ({ label: m, value: m }))
      setMutations(mutationsOptions)
    }
  }).catch((err) =>{
    console.log(err)
    trackError({ error: err, history: props.history })
    if (err && err.response && err.response.status === 403) {
      userAction({type: 'logout'})
    }
  })

  if (props.manualTrialToEdit && !edit) {
    setEdit(true)
    manualTrialForm.current = { ...props.manualTrialToEdit }
  }

  useEffect(() => {
    let objKeys = Object.keys(validators.msgs)
    let dataKeys = Object.keys(manualTrialForm.current)
    let count = 0
    let countData = 0
    dataKeys.forEach(d => { if (manualTrialForm.current[d] !== '') countData++ })
    objKeys.forEach(o => { if (validators.msgs[o]) count++ })
    if (count === 0 && countData !== 0 && validators.saveHit) sendManualData()
  }, [validators])

  if (mutations.length === 0) fetchFilters()

  return (
    <div style={styles.container}>
      {sections.map((content, i) =>  <div key={i}>
          {content.heading && <p className='biggerHeading'>{content.heading}</p>}
          <div style={styles['labelContainer'+content.type]}>
            {content.includes.map((label, i) => <FormContent validators={validators} key={i} mutations={mutations} topState={subState} labelSettings={label} changeState={formState} {...props} manualTrialForm={manualTrialForm}/>)}
          </div>
        </div>)}
        <React.Fragment >
          {ageWarning &&  <p style={{...styles.warning, margin: '0', fontSize:'14px'}}>Confirmation is required</p>}
          <p style={{...styles.disclaimer, display: 'flex', cursor:'pointer'}} onClick={e => setAgeCheck(!ageCheck)}><Icons icon={ageCheck ? 'check' : 'circleAlt'} style={styles.icon}/> Minimum and maximum age must be in months*</p>
          <button onClick={saveManual} style={{...btnStyles.button, marginLeft: '50'}} >
            <span>Save</span>
          </button>
          <button onClick={e => setManual(false)} style={{...btnStyles.button, marginLeft: '5px'}} >
            <span>Cancel</span>
          </button>
        </React.Fragment>
    </div>
  )
}

export default ManualTrial;
